/** A width × height grid of bytes, row-major: cell (x, y) is data[y * w + x]. */
export interface Grid {
  data: Uint8Array;
  w: number;
  h: number;
}

export function createGrid(w: number, h: number): Grid {
  return { data: new Uint8Array(w * h), w, h };
}
